import { useColorMode, useColorStyle } from '@tonic-one/react';
export const useSlfExceptionStyle = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const hoverBackgroundColor = {
    dark: 'rgba(255, 255, 255, 0.12)',
    light: 'rgba(0, 0, 0, 0.12)',
  }[colorMode];
  const cellHeight = 44;
  const headerHeight = 36;
  const rowsToDisplay = 30;
  const footerHeight = 12;
  const templateTableMaxHeight =
    headerHeight + rowsToDisplay * cellHeight + footerHeight;

  const tableStyleProps = {
    maxHeight: templateTableMaxHeight,
    // height: templateTableMaxHeight,
    // Uncomment the following line to specify the width and enable horizontal scrollbar
    width: '100%',
  };

  // Sync the scroll position of the table header and table body for horizontal scrolling
  const tableHeaderStyleProps = {
    overflow: 'auto',
  };
  const descriptionColor = colorStyle.color.secondary;
  const clearButtonColor = colorStyle.color.info;

  return {
    hoverBackgroundColor,
    tableStyleProps,
    tableHeaderStyleProps,
    descriptionColor,
    cellHeight,
    headerHeight,
    rowsToDisplay,
    templateTableMaxHeight,
    footerHeight,
    clearButtonColor,
  };
};

export const useKfContainRuleListStyle = () => {
  const cellHeight = 44;
  const headerHeight = 36;
  const rowsToDisplay = 30;
  const footerHeight = 12;
  const templateTableMaxHeight =
    headerHeight + rowsToDisplay * cellHeight + footerHeight;

  const tableStyleProps = {
    maxHeight: templateTableMaxHeight,
    // height: templateTableMaxHeight,
    // Uncomment the following line to specify the width and enable horizontal scrollbar
    width: '100%',
  };
  return {
    tableStyleProps,
  };
};
